'use client';
import { cn } from '@/lib/utils';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

const FilterBox = ({
  category,
  tags,
  isPending,
  startTransition,
  scrollToBlogStart,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();

  const selectedTags = params.get('tags') ? params.get('tags').split(',') : [];

  const toggleTag = (tag) => {
    let newTags;
    if (selectedTags.includes(tag)) {
      newTags = selectedTags.filter((t) => t !== tag);
    } else {
      newTags = [...selectedTags, tag];
    }

    const updateParams = () => {
      const newParams = new URLSearchParams(params.toString());
      newParams.set('page', '1'); // Reset to page 1 on filter change
      if (newTags.length > 0) {
        newParams.set('tags', newTags.join(','));
      } else {
        newParams.delete('tags');
      }
      router.push(`${pathname}?${newParams.toString()}`, { scroll: false });
    };

    // Wrap updateParams in a transition if provided
    const runUpdate = () => {
      if (startTransition) {
        startTransition(() => updateParams());
      } else {
        updateParams();
      }
    };

    // If scroll helper is available → scroll first, then update params
    // Else → directly update params
    if (scrollToBlogStart) {
      scrollToBlogStart(runUpdate);
    } else {
      runUpdate();
    }
  };

  return (
    <div className={` w-full transition-all duration-500 py-6 flex flex-col`}>
      <summary
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className="flex justify-between items-center gap-2 text-gray-900 transition-all duration-500 cursor-pointer"
      >
        <span className="font-inter-tight text-[#89D7DF] text-[18px] uppercase">
          {category}
        </span>

        <span className="text-[#89D7DF] text-[24px]">{isOpen ? '-' : '+'}</span>
      </summary>

      <div
        className={`w-full  ${
          isOpen
            ? 'overflow-visible max-h-screen transition-all duration-500 mt-4 '
            : 'overflow-hidden max-h-0 transition-all duration-500'
        }`}
      >
        <ul className="space-y-2 w-full">
          {tags?.map((item, index) => {
            const isChecked = selectedTags.includes(item);
            return (
              <li
                key={index}
                className={`w-full flex items-center transition-all duration-500 justify-between ${
                  isOpen ? 'opacity-100' : 'opacity-0'
                } ${isPending ? 'pointer-events-none opacity-50' : ''}`}
                onClick={() => toggleTag(item)}
              >
                <div className="flex justify-start items-center gap-2 w-full">
                  <label
                    htmlFor={item}
                    className="inline-flex items-center gap-2 w-full cursor-pointer"
                  >
                    <span
                      className={cn(
                        'flex flex-shrink-0 justify-center items-center border-[#6A6A6A] border-2 rounded-[3px] w-4 h-4 transition duration-300 cursor-pointer',
                        isChecked && 'bg-black border-transparent'
                      )}
                    >
                      {isChecked && (
                        <svg
                          className="fill-current w-3 h-3 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                        </svg>
                      )}
                    </span>
                    <div className="relative flex justify-between items-center w-full">
                      <span className="flex justify-start items-center gap-1 w-full font-inter-tight font-medium text-[#959595] text-[18px] select-none">
                        {item}
                      </span>
                    </div>
                  </label>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default FilterBox;
